module.exports = __webpack_public_path__ + "static/media/calendar_clock.f7632347.svg";